const steps = [
  {
    number: '01',
    icon: 'ri-file-list-3-line',
    title: 'Register Your Interest',
    description:
      'Complete our brief owner registration form. Tell us about your villa, your court, and what makes your property exceptional.',
  },
  {
    number: '02',
    icon: 'ri-search-eye-line',
    title: 'We Review Your Villa',
    description:
      'Our curation team carefully assesses your property against our quality criteria. We will be in touch personally to discuss your listing.',
  },
  {
    number: '03',
    icon: 'ri-layout-masonry-line',
    title: 'Build Your Profile',
    description:
      'Together we craft a premium villa profile covering photography guidance, compelling copy, and full court feature presentation.',
  },
  {
    number: '04',
    icon: 'ri-rocket-2-line',
    title: 'Go Live & Earn',
    description:
      'Your villa launches to our curated audience of high-net-worth padel travellers. Bookings arrive. Guests play. You benefit.',
  },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end justify-between mb-20 gap-8">
          <div>
            <p className="font-inter text-xs text-[#D4845C] uppercase tracking-[0.2em] font-medium mb-5">
              How It Works
            </p>
            <h2 className="font-cormorant text-5xl lg:text-6xl font-light text-[#2C2C2C] leading-[1.1]">
              From Introduction<br />
              <em className="italic">to Live in Four Steps.</em>
            </h2>
          </div>
          <p className="font-inter font-light text-[#6B6B6B] text-base max-w-sm leading-relaxed lg:text-right">
            We have made the process as effortless as possible. Your time is valuable and our onboarding reflects that.
          </p>
        </div>

        {/* Steps */}
        <div className="relative">
          {/* Connector line desktop only */}
          <div className="hidden lg:block absolute top-12 left-[calc(12.5%+8px)] right-[calc(12.5%+8px)] h-px bg-gradient-to-r from-transparent via-[#D4845C]/30 to-transparent" />

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10">
            {steps.map((step, idx) => (
              <div key={step.number} className="relative flex flex-col">
                {/* Number + Icon */}
                <div className="flex items-center gap-4 mb-6">
                  <div className="relative">
                    <div className="w-16 h-16 flex items-center justify-center rounded-full border-2 border-[#D4845C]/30 bg-white z-10 relative">
                      <i className={`${step.icon} text-xl text-[#D4845C]`} />
                    </div>
                    {idx < steps.length - 1 && (
                      <div className="lg:hidden absolute top-1/2 left-full w-8 h-px bg-[#D4845C]/20 -translate-y-1/2" />
                    )}
                  </div>
                  <span className="font-cormorant text-4xl font-light text-[#D4845C]/30">{step.number}</span>
                </div>

                <h3 className="font-cormorant text-2xl font-semibold text-[#2C2C2C] mb-3">{step.title}</h3>
                <p className="font-inter font-light text-[#6B6B6B] text-sm leading-relaxed">{step.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="mt-20 text-center">
          <button
            onClick={() => {
              const el = document.getElementById('lead-form');
              if (el) el.scrollIntoView({ behavior: 'smooth' });
            }}
            className="whitespace-nowrap bg-[#2C2C2C] text-white font-inter font-medium text-sm px-8 py-4 rounded-full hover:bg-[#3d3d3d] transition-colors duration-200 cursor-pointer inline-flex items-center gap-2"
          >
            Begin Your Registration
            <i className="ri-arrow-right-line" />
          </button>
        </div>
      </div>
    </section>
  );
}
